module.exports = __webpack_public_path__ + "static/media/bg2.3805eb14.svg";